import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { ANNOUNCEMENT_API } from "../constants/constants";
import { defaultErrorMsg, defaultHeaders } from "../utils/params";

export const announcementServiceApi = createApi({
  reducerPath: "announcementServiceApi",
  baseQuery: async (args, api, extraOptions) => {
    const baseQuery = fetchBaseQuery({
      baseUrl: ANNOUNCEMENT_API,
      prepareHeaders: async (headers, { getState }) => {
        const token = (getState() as any)?.auth?.access_token;

        return defaultHeaders(headers, token);
      },
    });

    const result = await baseQuery(args, api, extraOptions);

    await defaultErrorMsg(result);

    return result;
  },
  tagTypes: [
    "GetAnnouncementList",
    "GetAnnouncementDetails",
    "GetSupportList",
    "GetSupportDetails",
    "GetComments",
  ],
  keepUnusedDataFor: 2,
  endpoints: () => ({}),
});
